import { DataMap } from '@grapecity/wijmo.grid'

import { ListItem } from '../utility'
import { BaseEnumEx } from './base-enum-ex'

// NOTE: Make sure this stays in sync with the server-side enum (JobOwnershipRole.cs).
export enum JobOwnershipRole {
    ProjectManager = 1,
    Jca = 2,
    Superintendent = 3,
    ProjectEngineer = 4,
}

export class JobOwnershipRoleEx extends BaseEnumEx {
    public static toDisplay(item: JobOwnershipRole) {
        switch (item) {
            case JobOwnershipRole.ProjectManager:
                return 'Project Manager'
            case JobOwnershipRole.Jca:
                return 'JCA'
            case JobOwnershipRole.Superintendent:
                return 'Superintendent'
            case JobOwnershipRole.ProjectEngineer:
                return 'Project Engineer'
        }
        return 'Unknown'
    }

    public static toDataMap(): DataMap {
        return new DataMap(JobOwnershipRoleEx.toListItems(), 'value', 'display')
    }

    public static toListItems(): ListItem<number>[] {
        return [
            new ListItem(JobOwnershipRole.ProjectManager, JobOwnershipRoleEx.toDisplay(JobOwnershipRole.ProjectManager)),
            new ListItem(JobOwnershipRole.Jca, JobOwnershipRoleEx.toDisplay(JobOwnershipRole.Jca)),
            new ListItem(JobOwnershipRole.Superintendent, JobOwnershipRoleEx.toDisplay(JobOwnershipRole.Superintendent)),
            new ListItem(JobOwnershipRole.ProjectEngineer, JobOwnershipRoleEx.toDisplay(JobOwnershipRole.ProjectEngineer)),
        ]
    }
}
